"use client";

import * as React from "react";
import { cn } from "@/lib/utils";

interface ScrollAreaProps extends React.HTMLAttributes<HTMLDivElement> {
  readonly viewportClassName?: string;
}

/**
 * ScrollArea (stable): implémentation simple basée sur overflow-auto.
 * Garantit un comportement fiable (wheel + touch) avec un viewport scroll natif.
 */
function ScrollArea({
  className,
  viewportClassName,
  children,
  ...props
}: ScrollAreaProps) {
  return (
    <div
      data-slot="scroll-area"
      className={cn("relative min-h-0 min-w-0", className)}
      {...props}
    >
      <div
        data-radix-scroll-area-viewport
        data-slot="scroll-area-viewport"
        className={cn(
          "h-full w-full overflow-auto overscroll-contain",
          viewportClassName,
        )}
        style={{ WebkitOverflowScrolling: "touch" }}
      >
        {children}
      </div>
    </div>
  );
}

// Conservé pour compat (pas utilisé ailleurs actuellement)
function ScrollBar() {
  return null;
}

export { ScrollArea, ScrollBar };
